import React, { useState } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Close from '@mui/icons-material/Close';
import { Button } from '@/ui';
import { TabPane } from '../TabPane';
import { useTimeIntervals } from '../../../views/OfferBlocks/hooks';
import { Condition, NumberField, SelectField } from '../../FinalForm';

const DailyRestrictionPane = ({ push, pop }) => {
  const [currentCapAmount, setCurrentCapAmount] = useState(0);
  const timeIntervals = useTimeIntervals(15, 96);

  return (
    <TabPane tabId='Daily Restriction'>
      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
        <Grid size='grow'>
          <NumberField name='offer.criteriaDailyLimit' label='Daily Limit' />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
        <Grid size='grow'>
          <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
            Current Cap Amount: {currentCapAmount}
          </FormLabel>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
        <Grid size={{ xs: 12, lg: 12 }}>
          <Button
            color='success'
            sx={{ float: 'right' }}
            onClick={() =>
              push('offer.criteriaDayHourRestrictions', {
                restrictionDay: '',
                restriction: '',
              })
            }
          >
            Add Day Partings
          </Button>
        </Grid>
      </Grid>
      <FieldArray name='offer.criteriaDayHourRestrictions'>
        {({ fields }) =>
          fields.map((name, index) => (
            <Grid container spacing={2} key={name} sx={{ mt: 1, alignItems: 'start' }}>
              <Grid size='auto'>
                <Tooltip title='Remove Day Parting'>
                  <IconButton
                    color='error'
                    aria-label='Remove Day Parting'
                    onClick={() => {
                      pop('offer.criteriaDayHourRestrictions', index);
                    }}
                  >
                    <Close fontSize='small' />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid size='grow'>
                <SelectField
                  name={`${name}.restrictionDay`}
                  options={[
                    { value: '', option: 'Select Day' },
                    { value: 'sunday', option: 'Sunday' },
                    { value: 'monday', option: 'Monday' },
                    { value: 'tuesday', option: 'Tuesday' },
                    { value: 'wednesday', option: 'Wednesday' },
                    { value: 'thursday', option: 'Thursday' },
                    { value: 'friday', option: 'Friday' },
                    { value: 'saturday', option: 'Saturday' },
                    { value: 'weekdays', option: 'Weekdays' },
                    { value: 'weekends', option: 'Weekends' },
                  ]}
                />
              </Grid>
              <Grid size='grow'>
                <SelectField
                  name={`${name}.restriction`}
                  options={[
                    { value: '', option: 'Select Restriction' },
                    { value: 'Available', option: 'Available' },
                    { value: 'Unavailable', option: 'Unavailable' },
                    { value: 'Partially Restricted', option: 'Partially Restricted' },
                  ]}
                />
              </Grid>
              <Grid size='grow'>
                <Condition when={`${name}.restriction`} is={['Partially Restricted']}>
                  <SelectField
                    name={`${name}.restrictionStart`}
                    options={[{ value: '', option: 'Select Start' }, ...timeIntervals]}
                  />
                </Condition>
              </Grid>
              <Grid size='grow'>
                <Condition when={`${name}.restriction`} is={['Partially Restricted']}>
                  <SelectField
                    name={`${name}.restrictionEnd`}
                    options={[{ value: '', option: 'Select End' }, ...timeIntervals]}
                  />
                </Condition>
              </Grid>
            </Grid>
          ))
        }
      </FieldArray>
    </TabPane>
  );
};

export default DailyRestrictionPane;
